import QueryString from 'qs';
import {
    ADD_QUERY_PARAMS,
    ADD_QUERY_FILTER_PARAM,
    SET_QUERY_SORT_PARAM,
} from '../actions/QueryActions';

export const generateFetchQuerySerialized = (condition = {}, filterParams = {}) => {
    let queryObject = Object.assign({}, condition, filterParams);

    return QueryString.stringify(queryObject);
};

export const cleanFilterParams = filterParams => {
    let params = {};

    for (let param in filterParams) {
        if (!filterParams[param]) {
            continue;
        }

        if (param === 'sort') {
            continue;
        }

        params[param] = filterParams[param];
    }

    return params;
};

let uri = window.location.href.split('?')[1];
let searchParams = new URLSearchParams(uri);
let filterParams = {};
let sortDirection;

for (let param of searchParams) {
    let [key, value] = param;

    if (key === 'sort') {
        sortDirection = value;
    }

    Object.assign(filterParams, {[key]: value});
}

export const getFilterParam = paramName => {
    return filterParams[paramName] || undefined;
};

const fetchQuerySerialized = generateFetchQuerySerialized(filterParams);

const initialState = {
    pagination: {},
    condition: {},
    sortDirection: sortDirection,
    filterParams: filterParams,
    fetchQuerySerialized: fetchQuerySerialized,
    urlQuerySerialized: fetchQuerySerialized,
};

export default function QueryReducer(state = initialState, action) {
    let newState;
    let {type, payload} = action;

    switch (type) {
        case ADD_QUERY_FILTER_PARAM:
            let value = Object.values(payload)[0];
            let key = Object.keys(payload)[0];

            if (value === '') {
                delete state.filterParams[key];

                newState = Object.assign({}, state, {
                    filterParams: state.filterParams,
                });

                break;
            }

            newState = Object.assign({}, state, {
                filterParams: Object.assign(state.filterParams, payload),
            });

            break;

        case ADD_QUERY_PARAMS:
            newState = Object.assign({}, state, {
                filterParams: Object.assign(state.filterParams, payload),
            });

            break;

        case SET_QUERY_SORT_PARAM:
            newState = Object.assign({}, state, {
                sortDirection: payload.sortDirection,
            });

            break;
    }

    if (type.search('SUCCESS') >= 0) {
        if (payload && payload.pagination && Object.keys(payload.pagination).length !== 0) {
            newState = Object.assign({}, state, {
                pagination: payload.pagination,
            });
        }
    }

    if (newState) {
        let {condition, filterParams, sortDirection} = newState;
        let query;
        let clearFilterParams;

        clearFilterParams = cleanFilterParams(filterParams);

        if (sortDirection) {
            Object.assign(clearFilterParams, {sort: sortDirection});
        }

        query = generateFetchQuerySerialized(clearFilterParams);

        let params = query ? '?' + query : '';

        window.history.pushState({}, '', window.location.pathname + params);

        return Object.assign({}, newState, {
            fetchQuerySerialized: generateFetchQuerySerialized(condition, clearFilterParams),
            urlQuerySerialized: query,
        });
    }

    return state;
}